/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_header_search12 = /** @type {(inputs: {}) => string} */ () => {
	return `Discover`
};

const fr_header_search12 = /** @type {(inputs: {}) => string} */ () => {
	return `Découvrir`
};

const de_header_search12 = /** @type {(inputs: {}) => string} */ () => {
	return `Suchen`
};

const es_header_search12 = /** @type {(inputs: {}) => string} */ () => {
	return `Buscar`
};

const it_header_search12 = /** @type {(inputs: {}) => string} */ () => {
	return `Ricerca`
};

const ar_header_search12 = /** @type {(inputs: {}) => string} */ () => {
	return `يبحث`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "fr" | "de" | "es" | "it" | "ar" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const header_search12 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.header_search12(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("header_search12", locale)
	if (locale === "en") return en_header_search12(inputs)
	if (locale === "fr") return fr_header_search12(inputs)
	if (locale === "de") return de_header_search12(inputs)
	if (locale === "es") return es_header_search12(inputs)
	if (locale === "it") return it_header_search12(inputs)
	return ar_header_search12(inputs)
};
export { header_search12 as "HEADER_SEARCH" }